export default class Feature {
  featureId: string;
  name: string;
  featureType: string;
  description: string;
  pricePerMonth: number;
  initialPrice: number;
  enabled: boolean;

  constructor(
    featureId: string,
    name: string,
    featureType: string,
    description: string,
    pricePerMonth: number,
    initialPrice: number,
    enabled: boolean
  ) {
    this.featureId = featureId;
    this.name = name;
    this.featureType = featureType;
    this.description = description;
    this.pricePerMonth = pricePerMonth;
    this.initialPrice = initialPrice;
    this.enabled = enabled;
  }

  clone() {
    return new Feature(
      this.featureId,
      this.name,
      this.featureType,
      this.description,
      this.pricePerMonth,
      this.initialPrice,
      this.enabled
    );
  }

  static fromObject(obj: {
    description: string;
    enabled: boolean;
    featureId: string;
    featureType: string;
    initialPrice: number;
    name: string;
    pricePerMonth: number;
  }) {
    return new Feature(
      obj.featureId,
      obj.name,
      obj.featureType,
      obj.description,
      obj.pricePerMonth,
      obj.initialPrice,
      obj.enabled
    );
  }

  toObject() {
    return {
      description: this.description,
      enabled: this.enabled,
      featureId: this.featureId,
      featureType: this.featureType,
      initialPrice: this.initialPrice,
      name: this.name,
      pricePerMonth: this.pricePerMonth,
    };
  }
}
